import { calculatorEipotekaPost } from '@/api/routes/calculator-eipoteka';

/**
 * 
 * @param {Object} requestData 
 * @param {Object} [contextData={}] 
 * @param {string} [source='unknown'] 
 * @returns {Promise<Object>} 
 */
export async function submitRequestCall(requestData, contextData = {}, source = 'unknown') {
  const payload = {
    requestData, // { fio, phone, email }
    ...contextData, 
    source, 
    // resultId: contextData.resultId || 0,
    // coupon: contextData.coupon || '',
    // useTitul: contextData.useTitul || false,
    // admitadUid: getAdmitadUid(), 
  };

  // Логика для получения admitadUid и других общих параметров может быть здесь
  // или передаваться в contextData

  console.log(`[RequestService] Submitting request from ${source}:`, payload);
  return calculatorEipotekaPost('createRequest', payload);
}


